export class BaseModalController {
  constructor(protected $uibModalInstance) { }

  public fechar() {
    this.$uibModalInstance.dismiss('cancel');
  }
}
